import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from '../reducers/index';
import createHistory from 'history/createHashHistory';
import createSagaMiddleware from 'redux-saga';
import rootSaga from '../sagas/index';


const history = createHistory ();
const sagaMiddleware = createSagaMiddleware ();

const middlewares = [sagaMiddleware];

export default function configureStore (initialState) {
    const store = createStore (reducers, initialState,
        composeWithDevTools (applyMiddleware (...middlewares)));

    sagaMiddleware.run (rootSaga);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept ('../reducers/index', () => {
            const nextRootReducer = require ('../reducers/index');
            store.replaceReducer (nextRootReducer);
        });
    }
    return store;
}
export { history };



// WEBPACK FOOTER //
// ./store/index.js